import { computed } from '@angular/core';
import { signalStoreFeature, withComputed, withState } from '@ngrx/signals';

export interface SessionState {
  idToken: string | undefined;
  accessToken: string | undefined;
  refreshToken: string | undefined;
}

export const INITIAL_SESSION_STATE: SessionState = {
  idToken: undefined,
  accessToken: undefined,
  refreshToken: undefined
};

/** Partial to hand to patchState in order to clear the session. */
export const resetSession = (): SessionState => ({
  idToken: undefined,
  accessToken: undefined,
  refreshToken: undefined
});

export function withSession() {
  return signalStoreFeature(
    withState<SessionState>(INITIAL_SESSION_STATE),
    withComputed(({ idToken, accessToken, refreshToken }) => ({
      hasToken: computed(() => !!idToken() && !!accessToken() && !!refreshToken())
    }))
  );
}
